var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedSalesMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0%",
    fx: "0%",
    fy: "50%",
    r: "192.58%",
    gradientTransform: "matrix(0 -1 .88973 0 -.44 .5)",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070707",
    stopOpacity: 0.78,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070707",
    stopOpacity: 0,
    offset: "48.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.55 23.76c2.28.42 9.59-3.87 9.59-6.35 0-2.48-.85-5.76-9.22-5.76-8.37 0-15.53 4.98-15.48 6 .05 1 12.83 5.69 15.11 6.1z",
    fill: "url(#a)",
    opacity: 0.52,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-50 18.8 17.72)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 27.55L3.13 18.2a10.64 10.64 0 0 1 0-15.09 10.73 10.73 0 0 1 15.14 0 10.64 10.64 0 0 1 0 15.09l-7.57 9.34z",
    fill: "#00ADF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedSalesMarker);
export default __webpack_public_path__ + "static/media/featured_sales_marker.3b4bec0afaf54948680fe10175047709.svg";
export { ForwardRef as ReactComponent };